import { CRM_PET_PRODUCT_CATEGORIES, CRM_PET_SERVICE_CATEGORIES } from "../constants";

const BASE_COLUMNS = {
  customer: { key: "customer", label: "Cliente", size: "minmax(140px, 1.2fr)" },
  pet: { key: "pet", label: "Pet", size: "minmax(110px, .8fr)" },
  subscriber: { key: "subscriber", label: "Assinante", size: "105px" },
  formerSubscriber: { key: "formerSubscriber", label: "Ex-assinante", size: "115px" },
  frequency: { key: "frequency", label: "Frequência", size: "105px" },
  absence: { key: "absence", label: "Ausência", size: "95px" },
  lastSubscription: { key: "lastSubscription", label: "Última assinatura", size: "150px" },
  lastAppointment: { key: "lastAppointment", label: "Último agend.", size: "150px" },
  nextAppointment: { key: "nextAppointment", label: "Próximo agend.", size: "160px" },
  opportunities: { key: "opportunities", label: "Oportunidades", size: "minmax(180px, 1.4fr)" },
  contact: { key: "contact", label: "Contato", size: "130px" },
  actions: { key: "actions", label: "Ações", size: "125px" },
};

function categoryColumns(categories = []) {
  return categories.map((category) => ({
    key: `category:${category.code}`,
    categoryCode: category.code,
    label: category.label,
    size: "115px",
  }));
}

export function getCrmPetTableColumns(rule) {
  const commonStart = [BASE_COLUMNS.customer, BASE_COLUMNS.pet, BASE_COLUMNS.subscriber];
  const commonEnd = [
    BASE_COLUMNS.absence,
    BASE_COLUMNS.lastAppointment,
    BASE_COLUMNS.nextAppointment,
    BASE_COLUMNS.contact,
    BASE_COLUMNS.actions,
  ];

  if (rule === "ABSENT") return [...commonStart, ...commonEnd];

  if (rule === "POTENTIAL_SUBSCRIBER") {
    return [
      ...commonStart,
      // BASE_COLUMNS.formerSubscriber,
      BASE_COLUMNS.frequency,
      BASE_COLUMNS.absence,
      BASE_COLUMNS.lastSubscription,
      BASE_COLUMNS.lastAppointment,
      BASE_COLUMNS.nextAppointment,
      BASE_COLUMNS.contact,
      BASE_COLUMNS.actions,
    ];
  }

  if (rule === "NO_PRODUCT") {
    return [...commonStart, ...categoryColumns(CRM_PET_PRODUCT_CATEGORIES), ...commonEnd];
  }

  if (rule === "NO_ADDITIONAL") {
    return [...commonStart, ...categoryColumns(CRM_PET_SERVICE_CATEGORIES), ...commonEnd];
  }

  return [
    ...commonStart,
    BASE_COLUMNS.absence,
    BASE_COLUMNS.lastAppointment,
    BASE_COLUMNS.nextAppointment,
    BASE_COLUMNS.opportunities,
    BASE_COLUMNS.contact,
    BASE_COLUMNS.actions,
  ];
}

export function formatTableColumns(columns) {
  return columns.map((column) => `${column.label}:${column.size}`);
}
